/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_CASE_USAGE_SHEET_LIST = gql`
  query getCaseUsageSheetList(
    $limit: Int
    $offset: Int
    $type: String
    $orderBy: String
    $orderSortType: String
    $filters: CaseUsageSheetFilters
  ) {
    getCaseUsageSheetList(
      limit: $limit
      offset: $offset
      type: $type
      orderBy: $orderBy
      orderSortType: $orderSortType
      filters: $filters
    ) {
      __typename
      caseId
      caseExternalId
      salesRepId
      salesRep
      eventType
      eventId
      division
      eventStatus
      branchId
      branch
      accountId
      accountNumber
      accountName
      parentEventId
      parentEventType
      parentEventStatus
      parentCaseExternalId
      parentCaseId
      createdDate
      shippingAddessLine1
      shippingAddessLine2
      shippingPostalcode
      shippingCity
      shippingState
      shippingId
      shippingAddressNumber
      billingAddessLine1
      billingAddessLine2
      billingPostalcode
      billingCity
      billingState
      billingId
      billingAddressNumber
      qty
      orderType
      shipMethod
      eventDateTime
      poNumber
      patientId
      surgeonId
      surgeonFirstName
      surgeonLastName
      surgeonErpCode
      alignedSurgeonId
      alignedSurgeonName
      procedureId
      procedureName
      totalAmount
      diplayOrderType
      territoryNumber
      isAgencyRecord
      subInventoryCode
      hasUserHold
      userHoldReasons
      poAttachmentTimestamp
      signatureTimestamp
      hospitalPrintedName
      customerTitle
    }
  }
`;
